import { render, staticRenderFns } from "./search-results.vue?vue&type=template&id=35b1f8be&"
import script from "./search-results.vue?vue&type=script&lang=js&"
export * from "./search-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports